export default {
  WIZARD: {
    /** `/wizard/continue-or-start` */
    STEP_ONE: 1,
    /** `/wizard/discovery-config` */
    STEP_TWO: 2,
    /** `/wizard/configuration` */
    STEP_THREE: 3,
    /** `/wizard/overview-run` */
    STEP_FOUR: 4,
    /** `/wizard/export` */
    STEP_FIVE: 5,
  },
};
